import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const ShakoKouzou = props => {
  return <Dropdown.Static kubunKey='shako_kouzou' {...props} />
}
